import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsLogoVandewiele = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>



      <g fill="currentColor">
			<g>
				<path  d="M0.3579061,12.2580748c0.1144809,0.3836508,0.4065035,0.6888571,0.7844394,0.8204756l0.0582299,0.0199957
					v-2.2311506l-0.8483819,1.3717823C0.3521936,12.2391777,0.3579061,12.2580748,0.3579061,12.2580748z"/>
				<path  d="M1.6778324,10.9207907l-0.0582298-0.020216v2.2320299L2.462492,11.759944l-0.0054936-0.0186768
					C2.3442762,11.3584948,2.0542309,11.0532885,1.6778324,10.9207907z"/>
			</g>
			<g>
				<path  d="M4.0533724,12.3351622L4.122436,12.598217L4.1882,12.3351622l0.5195093-1.466507h0.5327101
					l-0.8220701,2.2359667H3.7969177l-0.8220704-2.2359667h0.5590155L4.0533724,12.3351622z"/>
				<path  d="M6.519536,12.6870346H5.6415544l-0.1479325,0.4175873H4.9642119l0.8154702-2.2359667h0.6313319
					l0.8187704,2.2359667H6.667469C6.667469,13.1046219,6.5195365,12.6870346,6.519536,12.6870346z M5.7862825,12.2825518H6.374856
					l-0.2268972-0.6444368l-0.0657635-0.2532024l-0.0690641,0.2532024L5.7862825,12.2825518z"/>
				<path  d="M7.436976,10.8686552h0.5557156l0.7069478,1.1738949l0.1709862,0.3551235l-0.0263052-1.5290184H9.37043
					v2.2359667H8.8147144L8.1077662,11.930727l-0.1709857-0.3584242l0.0263057,1.5323191H7.436976V10.8686552z"/>
				<path  d="M9.7551594,10.8686552h0.8582287c0.7069483,0,1.147541,0.4241877,1.147541,1.1212835
					s-0.4405928,1.1146832-1.147541,1.1146832H9.7551594V10.8686552z M11.2216663,11.9899387
					c0-0.4373407-0.2235966-0.6937952-0.6082783-0.6937952h-0.332119v1.38099h0.332119
					C10.9980698,12.6771336,11.2216663,12.4239788,11.2216663,11.9899387z"/>
				<path  d="M12.0733423,10.8686552h1.6046352v0.4175873H12.599453v0.4701986h0.9502974v0.4077835H12.599453v0.52281
					h1.0785246v0.4175873h-1.6046352V10.8686552z"/>
				<path  d="M15.5785255,11.8189535l-0.0526114-0.2367496l-0.0559111,0.2367496l-0.3617239,1.2856684h-0.5918264
					l-0.6609373-2.2359667h0.5622683l0.3584242,1.466507l0.0591631,0.2663555l0.0592117-0.2663555l0.4142876-1.466507h0.4603462
					l0.4110355,1.466507l0.0591621,0.2663555l0.0592117-0.2663555l0.3584251-1.466507h0.5326614l-0.6609364,2.2359667h-0.5852737
					C15.9435024,13.1046219,15.5785255,11.8189535,15.5785255,11.8189535z"/>
				<path  d="M17.4429626,10.8686552h0.5261097v2.2359667h-0.5261097V10.8686552z"/>
				<path  d="M18.3538017,10.8686552h1.6046352v0.4175873h-1.0785255v0.4701986h0.9502506v0.4077835h-0.9502506v0.52281
					h1.0785255v0.4175873h-1.6046352V10.8686552z"/>
				<path  d="M20.2675037,10.8686552h0.5261097v1.8084784h0.9831543v0.4274883h-1.509264V10.8686552z"/>
				<path  d="M22.0431709,10.8686552h1.6046352v0.4175873h-1.0785255v0.4701986h0.9502506v0.4077835h-0.9502506v0.52281
					h1.0785255v0.4175873h-1.6046352V10.8686552z"/>
			</g>
		</g>

    
    </SvgIcon>
  );
});

export default AppIconsLogoVandewiele;
